import Vue from 'vue'
import { AppState } from '@/store/modules/app/typings'

export default {
  pending (state: AppState, { key, status }: { key: string, status: boolean }) {
    Vue.set(state.pending, key, status)
  }
}
